export class CleanHelper {

  static cleanText(value?: string): string {
    return value ? value.trim() : '';
  }

  static fullName(first?: string, last?: string): string {
    return `${this.cleanText(first)} ${this.cleanText(last)}`.trim();
  }

  static digitsOnly(value?: string): string {
    return value ? value.replace(/\D/g, '') : '';
  }

  static decimalOnly(value?: string): string {
    const cleaned = value ? value.replace(/[^0-9.]/g, '') : '';
    const firstDot = cleaned.indexOf('.');
    if (firstDot === -1) {
      return cleaned;
    }
    return cleaned.substring(0, firstDot + 1) + cleaned.substring(firstDot + 1).replace(/\./g, '');
  }

  static hasValue(value: string | number | null | undefined): boolean {
    return value !== null && value !== undefined && String(value).trim() !== '';
  }

  static toDecimal(value: string | number | null | undefined): number | null {
    if (!this.hasValue(value)) {
      return null;
    }
    const parsed = Number(value);
    return isFinite(parsed) ? parsed : null;
  }

  static stripLeadingZeros(value?: string | number | null): string {
    const text = value == null ? '' : String(value).trim();
    return text.replace(/^0+(?=\d)/, '');
  }

  static toIsoDateOnly(value?: string): string {
    const dateOnly = this.cleanText(value).substring(0, 10);
    if (!/^\d{4}-\d{2}-\d{2}$/.test(dateOnly)) {
      return '';
    }
    const year = parseInt(dateOnly.substring(0, 4), 10);
    const month = parseInt(dateOnly.substring(5, 7), 10);
    const day = parseInt(dateOnly.substring(8, 10), 10);
    const date = new Date(year, month - 1, day);
    const isRealDate = date.getFullYear() === year
      && date.getMonth() === month - 1
      && date.getDate() === day;
    return isRealDate ? dateOnly : '';
  }
}



// WEBPACK FOOTER //
// ./src/app/core/helpers/clean-helper.ts